import { formatTo12Hour } from '@/lib/reservation.utils';
import { ReservationForm } from '@/types';
import { format } from 'date-fns';

export function ReservationSummary({ data }: { data: ReservationForm }) {
    return (
        <div className="rounded-md border bg-muted/50 p-3 text-sm">
            <p>
                Reservation from{' '}
                <strong>
                    {format(new Date(data.date), 'PPP')} at{' '}
                    {formatTo12Hour(data.start_time)}
                </strong>
            </p>
            <p>
                to{' '}
                <strong>
                    {format(
                        new Date(
                            data.end_time <= data.start_time
                                ? new Date(data.date).setDate(
                                      new Date(data.date).getDate() + 1,
                                  )
                                : data.date,
                        ),
                        'PPP',
                    )}{' '}
                    at {formatTo12Hour(data.end_time)}
                </strong>
            </p>
        </div>
    );
}
